import {
  KPI,
  KpiFilterAndTargetConfiguration,
  SalesLeadTimeController,
} from 'controllers/Analytics/SalesLeadTimeController'
import { useController } from 'customHooks/useController'
import React from 'react'
import { ErrorMessage } from 'store/Application/appActions'
import { useOrganizationContext } from 'utils/useOrganizationContext'

export const GetSalesLeadTimeData = async (
  controller: SalesLeadTimeController,
  fromState: string,
  toState: string
) => {
  try {
    return await controller.GetDataSet(fromState, toState)
  } catch (err) {
    throw err
  }
}

export const useSalesLeadTimeData = (
  fromState: string,
  toState: string,
  graphLocalStorageKeySuffix: string,
  targetValue: number,
  targetUnit: string,
  kpi: KPI,
  onError: (kpi: KPI, error: string) => void
) => {
  const { organizationId } = useOrganizationContext()

  const { controller, loading } = useController(
    () =>
      new SalesLeadTimeController(
        organizationId,
        graphLocalStorageKeySuffix,
        targetValue,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        targetUnit as any,
        kpi
      )
  )
  const [salesGraphData, setSalesGraphData] = React.useState(undefined)

  React.useEffect(() => {
    ;(async () => {
      try {
        const data = await GetSalesLeadTimeData(controller, fromState, toState)
        setSalesGraphData(data)
      } catch (err) {
        onError(kpi, err?.toString())
      }
    })()
    return () => {
      controller.CancelRequests()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controller, fromState, toState])

  const onSaveConfiguration = async (
    configurationData: KpiFilterAndTargetConfiguration
  ) => {
    try {
      controller.SetFilterConfiguration(configurationData)
      setSalesGraphData(await controller.GetDataSet(fromState, toState))
    } catch (err) {
      ErrorMessage('Analytics', err['message'] || err)
    }
  }

  const onSaveTarget = async (value: number, unit: string) => {
    try {
      await controller.SetTargetConfiguration(kpi, { value, unit })
      setSalesGraphData(controller.GraphCachedDataWithNewTargets())
    } catch (err) {
      ErrorMessage('analytics', err['message'] || err)
    }
  }

  return {
    controller,
    loading,
    salesGraphData,
    onSaveConfiguration,
    onSaveTarget,
  }
}
